import React from 'react';

const LoadingSpinner = ({ size = 'md', color = 'indigo' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const colorClasses = {
    indigo: 'border-indigo-600',
    blue: 'border-blue-600',
    green: 'border-green-600',
    red: 'border-red-600',
    white: 'border-white'
  };

  return (
    <div className={`
      ${sizeClasses[size]}
      ${colorClasses[color]}
      border-4 border-t-transparent
      rounded-full
      animate-spin
    `} />
  );
};

export const LoadingDots = ({ color = 'indigo' }) => {
  const colorClasses = {
    indigo: 'bg-indigo-600',
    blue: 'bg-blue-600',
    green: 'bg-green-600',
    red: 'bg-red-600',
    slate: 'bg-slate-600'
  };

  return (
    <div className="flex items-center gap-1 typing-indicator">
      <span className={`w-2 h-2 ${colorClasses[color]} rounded-full`} />
      <span className={`w-2 h-2 ${colorClasses[color]} rounded-full`} />
      <span className={`w-2 h-2 ${colorClasses[color]} rounded-full`} />
    </div>
  );
};

export const LoadingPulse = ({ size = 'md', color = 'indigo' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  const colorClasses = {
    indigo: 'bg-indigo-600',
    blue: 'bg-blue-600',
    green: 'bg-green-600',
    red: 'bg-red-600'
  };

  return (
    <div className={`
      ${sizeClasses[size]}
      ${colorClasses[color]}
      rounded-full
      animate-pulse
      opacity-75
    `} />
  );
};

export const LoadingBar = ({ progress = 0, color = 'indigo', height = 'sm' }) => {
  const heightClasses = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3'
  };

  const colorClasses = {
    indigo: 'bg-indigo-600',
    blue: 'bg-blue-600',
    green: 'bg-green-600',
    red: 'bg-red-600'
  };

  return (
    <div className={`w-full bg-slate-200 rounded-full ${heightClasses[height]} overflow-hidden`}>
      <div
        className={`${colorClasses[color]} ${heightClasses[height]} rounded-full transition-all duration-300 ease-out`}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export const LoadingOverlay = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-overlay">
      <div className="flex flex-col items-center gap-4">
        <LoadingSpinner size="lg" color="indigo" />
        <p className="text-slate-600 font-medium">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
